import UserRegistrationDataInterface from "@app/Interface/UserRegistrationDataInterface";

export default class UserRegistrationDataModel implements UserRegistrationDataInterface {
    jwt: string;
    password: string;
    enableTwoFactor: boolean;
    twoFactorType: string;
    twoFactorEmailAddress: string;
    twoFactorPhoneNumber: string;
    firstName: string;
    lastName: string;
    address: string;
    address2: string;
    city: string;
    state: string;
    zip: string;

    constructor(data?: UserRegistrationDataInterface) {
        this.jwt = data?.jwt ?? "";
        this.password = data?.password ?? "";
        this.enableTwoFactor = data?.enableTwoFactor ?? true;
        this.twoFactorType = data?.twoFactorType ?? "email";
        this.twoFactorEmailAddress = data?.twoFactorEmailAddress ?? "";
        this.twoFactorPhoneNumber = data?.twoFactorPhoneNumber ?? "";
        this.firstName = data?.firstName ?? "";
        this.lastName = data?.lastName ?? "";
        this.address = data?.address ?? "";
        this.address2 = data?.address2 ?? "";
        this.city = data?.city ?? "";
        this.state = data?.state ?? "";
        this.zip = data?.zip ?? "";
    }

}